<div>
    {{if BankBindStatus == 1}}
    <!-- 已绑定 -->
        <div style="text-align: center;padding: 20px 0 40px;margin: 20px 0;background: #F6F6F6;border-radius:10px;">
            <div class="cardEx realCard">
                <h3 class="bankName">{{BankInfo.BankName}}</h3>
                <h4 class="bankCode">
                    {{BankInfo.BankCardNum}}
                </h4>
                <div>
                    <span class="userName">{{BankInfo.BankAccountName}}</span>
                    <!--<span class="accountLocation">{{BankInfo.BranchName}}</span>-->
                </div>
            </div>
            <div style="text-align:center;margin-top:20px;font-size:14px;color: #666">
            注意：您的开户人姓名必须与您之前提交的认证身份证一致，</br>如果有问题请联系考米小管家
            </div>
        </div>
        <div style="text-align: center;padding: 40px;">
            <a class="w380btn themeColor" id="changeCardBtn">更换银行卡</a>
        </div>
    {{else if BankBindStatus == -1 || BankBindStatus == 2}}
    <!-- 未绑定|| 绑定失败 -->
        <div style="text-align: center;margin: 20px 0 40px">
            <div class="cardEx demoCard">
            </div>
        </div>
        <form class="layui-form">
            <div class="form-item">
                <label>开户银行</label>
                <div class="provinceCity">
                    <div class="form-block" style="width:130px">
                        <select name="bankName" id="bankName"></select>
                    </div>
                </div>
            </div>
            <div class="form-item">
                <label>银行卡号</label>
                <input class="custom-input" type="text" id="bankCode" placeholder="请输入银行卡号">
            </div>
            <div class="form-item">
                <label>开户人姓名</label>
                <input class="custom-input" type="text" id="openUserName" placeholder="请输入姓名">
            </div>
            <div class="form-item">
                <label>开户支行名称</label>
                <input class="custom-input" type="text" id="openBankName" placeholder="请输入支行名称">
            </div>
            <div class="form-item">
                <label>开户所在地</label>
                <div class="provinceCity">
                    <div class="form-block" style="width:130px">
                        <select name="mpprovince" lay-filter="mpprovince"></select>
                    </div>
                    <div class="form-block" style="width:130px;margin-left: 10px;">
                        <select name="mpcity" lay-filter="mpcity"></select>
                    </div>                
                </div>
            </div>
            <div class="formtip">注意：您的开户人姓名必须与您之前提交的认证身份证一致，如果有问题请联系小管家</div>

            <div style="text-align: center;padding: 60px;">
                <a class="w380btn themeColor" id="bindCardBtn">绑定银行卡</a>
            </div>
        </form>
    {{else if BankBindStatus == 0}}
        <div class="processing">
            <img class="processing-status" src="../../../../public/images/bankcard_processing.png">
            <div>银行信息已提交，请等待工作人员审核。</div>
        </div>
    {{/if}}

</div>